module.exports = __webpack_public_path__ + "static/media/mapycz.ade88877.png";